import { gql, useMutation } from '@apollo/client';
import { useMemo } from 'react';

import { prepareResponse } from '@work4all/data';

import { BillProjectHoursRequestFilter } from '@work4all/models/lib/Classes/BillProjectHoursRequestFilter.entity';
import { BillProjectHoursRequestSettings } from '@work4all/models/lib/Classes/BillProjectHoursRequestSettings.entity';
import { BillProjectHoursResult } from '@work4all/models/lib/Classes/BillProjectHoursResult.entity';
import { EMode } from '@work4all/models/lib/Enums/EMode.enum';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { createResponseData } from '../../../../../containers/mask-overlays/mask-overlay/views/erp/hooks/use-bz-shadow-object-api/use-shadow-bz-object-graphql';

export type BillProjectHoursVars = {
  filters: BillProjectHoursRequestFilter;
  settings: BillProjectHoursRequestSettings;
};

export const useBillProjectHoursResult = (props: { entity: Entities }) => {
  const { entity } = props;

  const request = useMemo(() => {
    const data = prepareResponse(Entities.billProjectHoursResult, {
      createdBzObjectCodes: null,
      dryRunBzObject: createResponseData(entity),
      totalBzObjectCount: null,
      warnings: [
        {
          apiValidationErrorType: null,
          data: null,
          property: null,
          validationDataType: null,
        },
      ],
    } as BillProjectHoursResult<EMode.query>);

    return gql`
    mutation billProjectHours(
        $filters: BillProjectHoursRequestFilter!
        $settings: BillProjectHoursRequestSettings!
        ) {
            billProjectHours(filters: $filters, settings: $settings) {
            ${data}
            }
    }
`;
  }, [entity]);

  const [generatePreview] = useMutation<
    { billProjectHours: BillProjectHoursResult },
    BillProjectHoursVars
  >(request);

  return { generatePreview };
};
